import { openInternalTarget } from '@/services/push/pushRouter';
import { resolveNotificationTarget } from '@/services/push/pushTarget';

// Clique numa notificação do sino (ComposedHeader e TrustflixHeader).
//
// Antes era `window.location = linkRedirect`: recarregava o app inteiro (no app
// nativo, splash + boot de novo) e, no domínio do produtor, ainda trocava de
// host porque o link é montado com o host central. Agora: rota NOSSA vai pelo
// router (mesmo caminho do toque em push — matrícula carregada e
// X-ApplicationId certo antes de abrir a aula); só link externo de verdade sai
// por window.location.
export function openNotification (notification) {
  const target = resolveNotificationTarget(notification);
  if (target) return openInternalTarget(target);
  // Fora da allowlist: mantém o comportamento antigo (o link vem do nosso
  // backend), só barrando esquema que executaria código.
  const link = notification && notification.linkRedirect;
  if (typeof link === 'string' && link.trim() && !/^\s*(javascript|data|vbscript):/i.test(link)) {
    window.location = link;
  }
  return Promise.resolve(false);
}
